import React from 'react';
import { Row, Col } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { PREFIX_URL } from 'configs/localData/constant';

import RestInputItem from 'components/RestInput/RestInputItem';
import RestSelect from 'components/RestInput/RestSelect';
import ReferenceInputWrapper from 'containers/rest/ReferenceInput';

const ProviderFilterForm = () => (
  <Row gutter={16}>
    <Col md={12} xs={12}>
      <ReferenceInputWrapper
        prefixUrl={PREFIX_URL.admin}
        resource="users/me/companies/basic-info"
        source="companyId"
        searchKey="name"
        notLikeFilter
        initialFilter={{ orderBy: 'name' }}
      >
        <RestSelect
          titleProp="name"
          valueProp="id"
          placeholder="centres.companyTitle"
          isFilterOption={false}
        />
      </ReferenceInputWrapper>
    </Col>
    <Col md={12} xs={12}>
      <RestInputItem
        source="name"
        placeholder="input.searchProvider"
        isShowTooltip
        inputProps={{ prefix: <SearchOutlined /> }}
      />
    </Col>
  </Row>
);

export default ProviderFilterForm;
